import Vue from 'vue'
import Vuex from 'vuex'
import tagsView from './tagsView'
import {
    mutations,
    USER_KEY,
    ACCOUNT_KEY,
    GROUP_KEY,
    CUR_ACCOUNT_ID_KEY,
    ANALYSIS_TYPE,
    TOKEN_KEY,
    ALL_ACCOUNT_KEY
} from './mutations'
import {apiVarietyList} from "@/api/analysis";
import {apiAccounts, apiGroups} from "@/api/user";
import moment from "moment";

Vue.use(Vuex)
export default new Vuex.Store({
    state: {
        token: localStorage.getItem(TOKEN_KEY) || '',
        user: JSON.parse(localStorage.getItem(USER_KEY) || '[]'),
        accounts: JSON.parse(localStorage.getItem(ACCOUNT_KEY) || '[]'),
        groups: JSON.parse(localStorage.getItem(GROUP_KEY) || '[]'),
        allAccounts: JSON.parse(localStorage.getItem(ALL_ACCOUNT_KEY) || '[]'),
        curAccountId: JSON.parse(localStorage.getItem(CUR_ACCOUNT_ID_KEY)) || [],
        analysisType: localStorage.getItem(ANALYSIS_TYPE) || 'single',
        // dateRange: JSON.parse(localStorage.getItem(DATE_RANGE_KEY)) || {label: '全周期', b_date: '', e_date: ''},
        dateRange: {label: '全周期', b_date: '', e_date: ''},
        showFooter: true,
        allVarieties: [],
        allVarietyNames: []
    },
    mutations,
    actions: {
        async fetchAllVarietiesIfNeeded({commit, state}) {
            if (state.allVarieties.length === 0) {
                const response = await apiVarietyList(); // 执行网络请求
                commit('SET_All_VARIETIES', response.data.data);

                let varietyNames = {}
                state.allVarieties.forEach(item => {
                    varietyNames[item.code] = item.name;
                })

                commit('SET_All_VARIETY_NAMES', varietyNames);
            }
        },
        async fetchAllAccounts({commit}) {
            let response = await apiAccounts();
            if (response.data.code === 0 && response.data.data) {
                let accounts = response.data.data
                if (accounts && accounts.length > 0) {
                    let effectiveAccounts = []
                    let AllAccounts = accounts.map(item => {
                        item.name = item.nickname + '(' + item.account_code + ')';
                        if (item.last_data_at !== 0 && item.status === 1) {
                            item.last_data_at_format = moment(new Date(item.last_data_at * 1000)).format('YYYY-MM-DD')
                            effectiveAccounts.push(item)
                        }
                        return item
                    })
                    if (effectiveAccounts.length > 0) {
                        commit('SET_ACCOUNTS', effectiveAccounts || [])
                        commit('SET_CUR_ACCOUNT_ID', [effectiveAccounts[0].id])
                    }
                    commit('SET_ALL_ACCOUNTS', AllAccounts || [])
                    commit('SET_ANALYSIS_TYPE', 'single')
                }
            }
        },
        async fetchAllGroups({commit}) {
            let response = await apiGroups();
            if (response.data.code === 0) {
                let groups = response.data.data || [];
                commit('SET_GROUPS', groups)
            }
        }
    },
    modules: {
        tagsView
    },
    getters: {
        isLoggedIn: state => state.token !== '',
        curAccountId: state => state.curAccountId,
        hasUserInfo: state => state.user !== null
    }
})
